import React from 'react';
import { connect } from 'react-redux';
import paging, { onCategoryScroll, reFetchConfig } from '@/hooks/paging';
import SearchCards from '../components/SearchCards';
import SearchesPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/SearchesPanelContainer';
import SearchesFilters from './SearchesFilters';

const SearchesPanelNarrow = ({
  canRead,
  category,
  currentPage,
  fetchData,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  searches,
  total,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus, reFetchConfig(searches, { pageSize, total }));
  return (
    <SearchesPanelContainer readErrors={readErrors} canRead={canRead} className="aridhia-searches-panel-narrow">
      <div className="sticky-panel-header">
        <SearchesFilters category={category} className="aridhia-list-filter" fluid />
      </div>
      <SearchCards
        category={category}
        handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
        items={searches}
        itemsPerRow={1}
        onCheckBoxClick={onCheckBoxClick}
        readErrors={readErrors}
        readStatus={readStatus}
      />
    </SearchesPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchesPanelNarrow);
